import Home from './Home'
import Login from './Login'
import BillServices from "./BillServices";
import ReceiptBillServices from './ReceiptBillServices'
import ForgetPass from './FrogetPass'
import Register from './Register'
import RegisterWithReferer from "./RegisterWithReferer";
import Verify from './Verify'
import Logout from './Logout'
import Increase from './Increase'
import NamadUser from './NamadUser'

import { Profile, ProfileUpdate, ProfileAuthenticate, ProfileShebaNumbers, ProfileAddresses, ProfileChangPassword, ProfileNamad } from './profile'
import { GatewayGet, GatewayCreate, GatewayUpdate, GatewayDetails, GatewayAllotment, GatewayTransactionsReport } from './gateway'
import { UserGet, UserDetails, UserActivityLog, ChangeUserPassword } from './user'
import { TicketComments, TicketGet, TicketCreate } from './ticket'
import { TransactionGet } from './transaction'
import { ShaparakRequestsGet } from './shaparakRequests'
import { StoreCreate, StoreGet, StoreUpdate ,StoreCoupon, StoreCoupons} from './store'
import { ProductCreate, ProductGet, ProductUpdate, ProductDetails ,ProductTags, ProductDiscounts} from './product'
import {
    PardakhtShakhsiGet,
    PardakhtShakhsiDetails,
    PardakhtShakhsiDirect,
    PardakhtShakhsiCheckout,
    PardakhtShakhsiReceipt
} from './pardakhtShakhsi'

import { NotificationGet } from './notification'
import { NotificationSmsGet, RechargeResult } from './notificationSms'

import { StorePage, ProductPage , AllCart} from './page'

import { AccessDenied } from './exception'

import { VerifyMail } from './verifyMail'

import { PspRequestGet, PspRequestDetails } from "./pspRequest";

import { SettlementGet, SettlementDetails, SettlementFiles, SettlementVpnLog } from './settlement'

import { PaymanGet, PaymanCreate, PaymanDetails, PaymanUpdate } from './payman'
import { IVRGet, IVRCreate, IVRDetails, IVRUpdate } from './ivr'
import { DedicatedGet, DedicatedCreate, DedicatedDetails, DedicatedUpdate, DedicatedAllotment, DedicatedStakeholders } from './dedicated'
import { NewsGet, NewsCreate, NewsUpdate, ShowNews } from "./news";
import {
    CollectiveGet,
    CollectiveDetails,
    CollectiveGatewayDetails,
    CollectiveActiveGateways,
    CollectiveCreate,
} from "./collective";
import {
    MarketingDashboard,
    MarketingTools,
    MarketerSubsets,
    MarketingSetting,
    MarketerManaging,
    SubsetsPSPTransactionsReport,
    SubsetsAppTransactionsReport,
    SubsetsSettlementsReport
} from './marketing'
import { BlackList } from './security'
import { GatewaysReports, UsersReports } from './reports'
import { MoneyRequestGet, MoneyRequestCreate, MoneyRequestPay, MoneyRequestReceipt } from './moneyRequest'

import { OnlineFactorCreateItems,OnlineFactorGetItems,OnlineFactorShow,OnlineFactorCustomers,OnlineFactorCreateCustomer,OnlineFactorShowCustomer,OnlineFactorGetFactor,
    OnlineFactorCreateFactor,OnlineFactorShowFactor, OnlineFactorPayment } from './online-factor'

import {CreateVip, UpdateVip} from "./special"

export {
    Home,
    Increase,
    Login,
    BillServices,
    ReceiptBillServices,
    ForgetPass,
    Register,
    RegisterWithReferer,
    Verify,
    Logout,
    NamadUser,
    Profile,
    ProfileUpdate,
    ProfileAuthenticate,
    ProfileShebaNumbers,
    ProfileAddresses,
    ProfileChangPassword,
    ProfileNamad,
    GatewayGet,
    GatewayCreate,
    GatewayUpdate,
    GatewayDetails,
    GatewayAllotment,
    GatewayTransactionsReport,
    UserGet,
    UserDetails,
    UserActivityLog,
    ChangeUserPassword,

    TicketGet,
    TicketCreate,
    TicketComments,
    TransactionGet,
    StoreGet,
    StoreCreate,
    StoreUpdate,
    StoreCoupon,
    StoreCoupons,
    ProductGet,
    ProductCreate,
    ProductUpdate,
    ProductDetails,
    ProductDiscounts,
    ProductTags,

    PardakhtShakhsiGet,
    PardakhtShakhsiDetails,
    PardakhtShakhsiDirect,
    PardakhtShakhsiCheckout,
    PardakhtShakhsiReceipt,
    NotificationGet,
    NotificationSmsGet,
    RechargeResult,
    VerifyMail,

    SettlementGet,
    SettlementDetails,
    SettlementFiles,
    SettlementVpnLog,

    PaymanGet,
    PaymanCreate,
    PaymanDetails,
    PaymanUpdate,

    IVRUpdate,
    IVRCreate,
    IVRDetails,
    IVRGet,

    DedicatedUpdate,
    DedicatedDetails,
    DedicatedCreate,
    DedicatedGet,
    DedicatedAllotment,
    DedicatedStakeholders,

    MoneyRequestGet,
    MoneyRequestCreate,
    MoneyRequestPay,
    MoneyRequestReceipt,

    StorePage,
    ProductPage,
    AllCart,

    PspRequestGet,
    PspRequestDetails,

    MarketingDashboard,
    MarketingTools,
    MarketerSubsets,
    MarketingSetting,
    MarketerManaging,
    SubsetsPSPTransactionsReport,
    SubsetsAppTransactionsReport,
    SubsetsSettlementsReport,

    BlackList,

    AccessDenied,
    NewsGet,
    NewsCreate,
    NewsUpdate,
    ShowNews,

    CollectiveGet,
    CollectiveDetails,
    CollectiveGatewayDetails,
    CollectiveActiveGateways,
    CollectiveCreate,

    UsersReports,
    GatewaysReports,

    ShaparakRequestsGet,

    OnlineFactorCreateItems,
    OnlineFactorGetItems,
    OnlineFactorShow,
    OnlineFactorCustomers,
    OnlineFactorCreateCustomer,
    OnlineFactorShowCustomer,
    OnlineFactorGetFactor,
    OnlineFactorCreateFactor,
    OnlineFactorShowFactor,
    OnlineFactorPayment,

    //VIP gateway
    UpdateVip,
    CreateVip

}